import CountryCode from "models/CountryCode";
import { ICountries } from "./useCountrySelect";
import assetsLocations from "assetLocations";

const defaultCountries: ICountries = {
    [CountryCode.AU]: {
        label: "Australia",
        flagImageLocation: assetsLocations.flags.AU,
    },
    [CountryCode.AT]: {
        label: "Austria",
        flagImageLocation: assetsLocations.flags.AT,
    },
    [CountryCode.BE]: {
        label: "Belgium",
        flagImageLocation: assetsLocations.flags.BE,
    },
    [CountryCode.CA]: {
        label: "Canada",
        flagImageLocation: assetsLocations.flags.CA,
    },
    [CountryCode.DK]: {
        label: "Denmark",
        flagImageLocation: assetsLocations.flags.DK,
    },
    [CountryCode.FI]: {
        label: "Finland",
        flagImageLocation: assetsLocations.flags.FI,
    },
    [CountryCode.FR]: {
        label: "France",
        flagImageLocation: assetsLocations.flags.FR,
    },
    [CountryCode.DE]: {
        label: "Germany",
        flagImageLocation: assetsLocations.flags.DE,
    },
    [CountryCode.IT]: {
        label: "Italy",
        flagImageLocation: assetsLocations.flags.IT,
    },
    [CountryCode.NL]: {
        label: "Netherlands",
        flagImageLocation: assetsLocations.flags.NL,
    },
    [CountryCode.NZ]: {
        label: "New Zealand",
        flagImageLocation: assetsLocations.flags.NZ,
    },
    [CountryCode.NO]: {
        label: "Norway",
        flagImageLocation: assetsLocations.flags.NO,
    },
    [CountryCode.PL]: {
        label: "Poland",
        flagImageLocation: assetsLocations.flags.PL,
    },
    [CountryCode.ES]: {
        label: "Spain",
        flagImageLocation: assetsLocations.flags.ES,
    },
    [CountryCode.SE]: {
        label: "Sweden",
        flagImageLocation: assetsLocations.flags.SE,
    },
    [CountryCode.CH]: {
        label: "Switzerland",
        flagImageLocation: assetsLocations.flags.CH,
    },
    [CountryCode.GB]: {
        label: "United Kingdom",
        flagImageLocation: assetsLocations.flags.GB,
    },
    [CountryCode.US]: {
        label: "United States",
        flagImageLocation: assetsLocations.flags.US,
    },
};

export default defaultCountries;
